module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1176570514/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main